import React from "react";

import RssFeedList from "./RssFeedList";
import {Helmet} from "react-helmet";
import {Link} from "react-router";

function Digital343() {
    return (
        <>
            <Helmet>
                <script src={`${process.env.PUBLIC_URL}/assets/js/fraudio.min.js`} type="text/javascript" />
                <link rel="stylesheet" href={`${process.env.PUBLIC_URL}/assets/css/fraudio.css`} />
            </Helmet>

            <div className="breadcumb bg-overlay-one">
                <div className="breadcumb__bottom-thumb">
                    <img src="assets/images/thumb/banner-bid.png" alt="" />
                </div>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="breadcumb__wrapper">
                                <span className="breadcumb__title">
                                    <span className="breadcumb__title-lighten" style={{color:"#0a0a0a"}}>304</span> DIGITAL
                                </span>
                                <ul className="breadcumb__list">
                                    <li className="breadcumb__item">
                                        <Link to="/" className="breadcumb__link" reloadDocument>
                                            <i className="las la-home" /> Ana Sayfa
                                        </Link>
                                    </li>
                                    <li className="breadcumb__item"> //</li>
                                    <li className="breadcumb__item-text">304 Digital Podcast</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
        <RssFeedList feedUrl="https://feeds.simplecast.com/xZFNy8N_" pageSize={10} />

        </>
    );
}

export default Digital343;